export default "__VITE_PUBLIC_ASSET__0bf1a7bd__"